import script from "./CardsPrintedView.vue?vue&type=script&setup=true&lang=js"
export * from "./CardsPrintedView.vue?vue&type=script&setup=true&lang=js"

import "./CardsPrintedView.vue?vue&type=style&index=0&id=72e3c1f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72e3c1f0"]])

export default __exports__